import React from "react";
import { Scale, ShieldCheck, Lightbulb } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: "01",
  title: "Partnership attiva",
  description: "Collaboriamo con clienti e professionisti come partner, unendo competenze e prospettive per\ngenerare valore, innovazione e miglioramento continuo.",
  icon: Scale
}, {
  id: "02",
  title: "Side-by-side support",
  description: "Rendiamo accessibili norme complesse e stratificate, trasformandole in indicazioni operative\nsemplici e orientate al business.",
  icon: ShieldCheck
}, {
  id: "03",
  title: "Compliance business-focused",
  description: "Rendiamo accessibili norme complesse e stratificate, trasformandole in indicazioni operative\nsemplici e orientate al business.",
  icon: Lightbulb
}];
export default function WhyJoinUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}